// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  hmr: false,
  // baseURL : 'http://185.205.141.4:3002',
  //185.205.141.4
  // baseURL: 'http://52.76.209.187:8000',
  // baseURL: 'https://api.autotransfercgm.com',
  //    baseURL: 'http://122.248.235.58',
  //  baseURL:'http://localhost',
  // baseURL:'http://18.139.13.107:4900',
  // baseURL: 'http://13.212.217.113:4900',
  //production server
  baseURL:'https://autotransfercgm.com',
  //public ip
  // baseURL:'http://175.41.187.193',
  //private  ip
  //baseURL: "http://localhost:8000",
  //   baseURL:'http://103.60.136.96:8000',
  //baseURL:'https://www.okmart.shop',
  // baseURL:'http://172.31.42.51:8000',
  // baseURL:'http://54.179.42.19:8000',//preprod
  // baseURL:'https://automatictransfercgm.com',

  // Dashboard API - AT
  CompanyBaseBranchBasedDonutChart:
    "api/AutoTrans/DashBoard/CompanyBaseBranchBasedDonutChart",
  CompanyBaseBranchBasedDonutChartTableData:
    "api/AutoTrans/DashBoard/CompanyBaseBranchBasedDonutChartTableData",
  CompanyBaseBranchBasedBarChart:
    "api/AutoTrans/DashBoard/CompanyBaseBranchBasedBarChart",
  CompanyBaseBranchBasedBarChartTableData:
    "api/AutoTrans/DashBoard/CompanyBaseBranchBasedBarChartTableData",
  CompanyBaseBranchBasedLineChart:
    "api/AutoTrans/DashBoard/CompanyBaseBranchBasedLineChart",
  CompanyBaseBranchBasedLineChartTableData:
    "api/AutoTrans/DashBoard/CompanyBaseBranchBasedLineChartTableData",
  CompanyBaseBranchBasedProgressChart:
    "api/AutoTrans/DashBoard/CompanyBaseBranchBasedProgressChart",
  CompanyBaseBranchBasedProgressChartTableData:
    "api/AutoTrans/DashBoard/CompanyBaseBranchBasedProgressChartTableData",

  CompanyBaseTableDataAtFg: "api/AutoTrans/DashBoard/CompanyBaseTableData",
  companybaseMonthwiselist: "api/AutoTrans/DashBoard/companybaseMonthwiselist",
  companybaseBarchart: "api/AutoTrans/DashBoard/companybaseBarchart",
  companybaseLinechart: "api/AutoTrans/DashBoard/companybaseLinechart",
  CompanyBasePieChart: "api/AutoTrans/DashBoard/CompanyBasePieChart",
  CompanyBaseProgressChart: "api/AutoTrans/DashBoard/CompanyBaseProgressChart",

  // Dashboard API - AR
  RepayPeriodDropdownDetailsCB: "api/AutoTrans/DashBoard/getAllPeriodData",
  barchartAutorepayment: "api/AutoTrans/DashBoard/repaymentcompanybaseBarchart",
  barchartAutorepaymentTableData:
    "api/AutoTrans/DashBoard/RepaymentCompanyBaseBarChartTableData",
  RepaymentProgressChart:
    "api/AutoTrans/DashBoard/RepaymentCompanyBaseProgressChart",
  RepaymentProgressChartTable:
    "api/AutoTrans/DashBoard/RepaymentCompanyBaseProgressChartTableData",
  RepayCBpieChart: "api/AutoTrans/DashBoard/RepaymentCompanyBasePieChart",
  repaymentcompanybaseLinechartCPB:
    "api/AutoTrans/DashBoard/repaymentcompanybaseLinechart",
  CompanyDashboardCard:
    "api/AutoTrans/DashBoard/repaymentcompanybaseMonthwiselist",
  companybaserepairymenttable:
    "api/AutoTrans/DashBoard/RepaymentCompanyBaseTableData",
  cbrepairymenttableSecondPage:
    "api/AutoTrans/DashBoard/RepaymentCompanyBasePieChartTableData",
  repaymentCompanyBaseLineChartTableData:
    "api/AutoTrans/DashBoard/RepaymentCompanyBaseLineChartTableData",
  RepaymentCompanyBaseBranchBasedBarChart:
    "api/AutoTrans/DashBoard/RepaymentCompanyBaseBranchBasedBarChart",
  CompanyDetailsFilterFirstBase:
    "api/AutoTrans/DashBoard/GetAutoRepaymentCompanyList",
  RepaymentCompanyBaseBranchBasedLineChart:
    "api/AutoTrans/DashBoard/RepaymentCompanyBaseBranchBasedLineChart",
  repaymentDonutChart:
    "api/AutoTrans/DashBoard/RepaymentCompanyBaseBranchBasedDonutChart",
  RepaymentCompanyBaseBranchBasedBarChartTableData:
    "api/AutoTrans/DashBoard/RepaymentCompanyBaseBranchBasedBarChartTableData",
  RepaymentCompanyBaseBranchBasedLineChartTableData:
    "api/AutoTrans/DashBoard/RepaymentCompanyBaseBranchBasedLineChartTableData",
  repaymentDonutChartTableData:
    "api/AutoTrans/DashBoard/RepaymentCompanyBaseBranchBasedDonutChartTableData",
  autoTransferCompanybaseFilter:
    "api/AutoTrans/DashBoard/GetAutotransferCompanyList",
  atIndividualFilter:
    "api/AutoTrans/DashBoard/GetAutotransferIndividualCompanyList",

  // baseURL:'https://automatictransfercgm.com',
  getAllCompanyBasesList: "api/AutoTrans/CompanyBaseList",
  CreateAllUserDetails: "api/AutoTrans/User/CreateUser",
  GetAllCompanyDetails: "api/AutoTrans/GetCompanyList",
  GetAllproductgroup: "api/AutoTrans/GetProductList",
  GetBranchListValue: "api/AutoTrans/GetBranchList",
  GetDivisionValue: "api/AutoTrans/GetDivisionList",
  GetDistrictListvalue: "api/AutoTrans/GetDistrictList",
  GetAllTownShipvalue: "api/AutoTrans/GetTownShipList",
  GetAllCityTownvalue: "api/AutoTrans/GetCityTownList",
  GetAllAdvanceMerchantNo: "api/AutoTrans/GetAdvanceMerchantNo",
  UserTransactionModuleList: "api/AutoTrans/User/UserModuleList",
  UserRoleTypeList: "api/AutoTrans/User/UserRoleList",
  GetUserNameFilterList: "api/AutoTrans/User/GetAllUserList",
  CreateIndividualData: "api/AutoTrans/CreateIndividualData",
  GetAllTransferList: "api/AutoTrans/TransferList",
  ReportList: "api/AutoTrans/Report",
  CreateScheduleDetailsTimebase: "api/AutoTrans/CreateScheduleDetails",
  GetIndividualWithAdvNoList: "api/AutoTrans/GetIndividualWithAdvNoList",
  GetUserList: "api/AutoTrans/User/GetUserList",
  login: "api/AdminPanel/login",
  deleteTransType: "api/AutoTrans/DeleteTransDetails",
  deleteUserData: "api/AutoTrans/User/DeleteUser",
  deleteScheduleList: "api/AutoTrans/DeleteScheduleList",
  ServiceStatus: "api/AutoTrans/StatusCron",
  UploadCompanyDetails: "api/AutoTrans/UploadCompanyDetails",
  UploadIndividualDetails: "api/AutoTrans/UploadIndividualDetails",
  ChangePassword: "api/AutoTrans/User/ChangePassword",
  UserRoleList: "api/AutoTrans/User/UserRoleList",
  UserModuleList: "api/AutoTrans/User/UserModuleList",
  GetAddFiveNumber: "api/AutoTrans/GetAddFiveNumber",
  ActivateAddFiveNumber: "api/AutoTrans/ActivateAddFiveNumber",
  SendOtp: "api/AutoTrans/User/SendOTP",
  VerifyOtp: "api/AutoTrans/User/VerifyOTP",
  UpdateTimeService: "api/AutoTrans/StartCron",
  // MonthBasedMethod: 'api/AutoTrans/MonthbasedCount',
  ProductBasedMethod: "api/AutoTrans/ProductBased",
  BranchBasedMethod: "api/AutoTrans/BranchBased",
  BranchBasedMethodByPieChart: "api/AutoTrans/BranchBasedByPieChart",
  NewPassword: "api/AutoTrans/User/NewPassword",
  ExporttoExcel: "api/AutoTrans/ExportCompanyDetails",
  ExporttoExcelCompany: "api/AutoTrans/ExportCompanyDetails",
  ExporttoExcelTransfer: "api/AutoTrans/ExportTransferList",
  ExporttoExcelUser: "api/AutoTrans/User/ExportUserList",
  ExporttoExcelReport: "api/AutoTrans/ExportReport",
  ExporttoExcelReportDownload: "api/AutoTrans/DownloadReportData",
  BlockTransfer: "api/AutoTrans/AutoBlockTransfer",
  PasswordAuth: "api/AutoTrans/BlockUser",
  Search: "api/AutoTrans/Search",
  GroupByCompany: "api/AutoTrans/GroupByCompany",
  GroupByTransferBase: "api/AutoTrans/GroupByTransferBase",
  GroupByDate: "api/AutoTrans/GroupByDate",
  GroupBycompanyonly: "api/AutoTrans/GroupByCompanySeparateReport",
  GroupByTransferBaseBoth: "api/AutoTrans/GroupByTransferBaseSeparateReport",
  GroupByDateBoth: "api/AutoTrans/GroupByDateSeparateReport",
  GroupByList: "api/AutoTrans/GroupByList",
  GetUserPassword: "api/AutoTrans/User/getPwd",
  FoundIfDublicateByExcel: "api/AutoTrans/DownloadErrorData",
  ProfilePicUpload: "api/AutoTrans/User/ProfileImageUpload",
  UpdateSuperAdminProfileImage: "api/AutoTrans/UpdateSuperAdminProfileImage",
  RemoveProfileImage: "api/AutoTrans/User/DeleteUserImageUrl",
  CompanyIndividualData: "api/AutoTrans/GroupByDateTransType",
  CompanyAutotransferData: "api/AutoTrans/GroupByDateSeparteCompany",
  CompanyfilterOnlyBranchData: "api/AutoTrans/GroupByDateSeparteBranch",
  CompanyfilterTransferBaseData: "api/AutoTrans/GroupByDateSeparteTransferBase",
  IndividualfilterDate: "api/AutoTrans/GroupByDateSeparteIndividaul",
  IndividualTransferFilterDate: "api/AutoTrans/GroupByDateIndividualTB",
  BothTransTypeCP: "api/AutoTrans/GroupByDateTransType",
  BothTransTypeIB: "api/AutoTrans/GroupByTTViewIndividual",
  BothScheduleTypeCPB: "api/AutoTrans/GroupByDateScheduleTypeCB",
  BothScheduleTypeIB: "api/AutoTrans/GroupByDateScheduleType",
  BothBasedByGroupByAdmin: "api/AutoTrans/BothBasedByGroupByAdmin",
  repaymentUploadCompanyDetails: "api/AutoTrans/UploadRepaymentCompanyDetails",
  getAllRepaymentCompanyBase: "api/AutoTrans/RepaymentCompanyBaseList",
  repaymentExporttoExcelCompany: "api/AutoTrans/ExportRepaymentCompanyDetails",
  destinationNumberDropdown: "api/AutoTrans/GetDestinationNo",
  sourceNumberDropdown: "api/AutoTrans/GetSourceNo",
  CreateRepaymentScheduleTranferDetails:
    "api/AutoTrans/CreateRepaymentScheduleDetails",
  createRepaymentIndividaulBase: "api/AutoTrans/CreateRepaymentIndividualData",
  GetAllAutoRepayTransferDetails: "api/AutoTrans/RepamentTransferList",
  GetPaymentTypeList: "api/AutoTrans/User/GetPaymentTypeList",
  repaymentExporttoExcelTransferDetails:
    "api/AutoTrans/ExportRepaymentTransferList",
  GetAllRepaymentReportList: "api/AutoTrans/RepaymentReport",
  repaymentexporttoexcelReports: "api/AutoTrans/ExportRepaymentReport",
  DeleateTransferDetail: "api/AutoTrans/DeleteRepaymentTransDetails",
  RepaymentGroupBycompanyonly:
    "api/AutoTrans/RepaymentGroupByCompanySeparateReport",
  RepaymentGroupByTransferBaseBoth:
    "api/AutoTrans/RepaymentGroupByTransferBaseSeparateReport",
  RepaymentGroupByDateBoth: "api/AutoTrans/RepaymentGroupByDateSeparateReport",
  RepaymentBothBasedByGroupByAdmin:
    "api/AutoTrans/RepaymentBothBasedByGroupByAdmin",
  RepaymentGroupByCompany: "api/AutoTrans/RepaymentGroupByCompany",
  RepaymentGroupByTransferBase: "api/AutoTrans/RepaymentGroupByTransferBase",
  RepaymentGroupByDate: "api/AutoTrans/RepaymentGroupByDate",

  RepayBothTransTypeCP: "api/AutoTrans/RepaymentGroupByDateTransType",
  RepayBothTransTypeIB: "api/AutoTrans/RepaymentGroupByTTViewIndividual",
  RepayBothScheduleTypeCPB: "api/AutoTrans/RepaymentGroupByDateScheduleTypeCB",
  RepayBothScheduleTypeIB: "api/AutoTrans/RepaymentGroupByDateScheduleType",
  RepayCompanyAutotransferData:
    "api/AutoTrans/RepaymentGroupByDateSeparteCompany",
  RepayCompanyfilterOnlyBranchData:
    "api/AutoTrans/RepaymentGroupByDateSeparteBranch",
  RepayCompanyfilterTransferBaseData:
    "api/AutoTrans/RepaymentGroupByDateSeparteTransferBase",
  RepayIndividualfilterDate:
    "api/AutoTrans/RepaymentGroupByDateSeparteIndividaul",
  RepayIndividualTransferFilterDate:
    "api/AutoTrans/RepaymentGroupByDateIndividualTB",
  companyBaserepairymentbranchwisetable:
    "api/AutoTrans/DashBoard/RepaymentCompanyBaseBranchBasedTableData",
  RepaymentCompanyBaseBranchBasedprogressChart:
    "api/AutoTrans/DashBoard/RepaymentCompanyBaseBranchBasedProgressChart",
  RepaymentTopTenprogressChart:
    "api/AutoTrans/DashBoard/RepaymentCompanyBaseDestinationNumberBasedProgressChartData",
  RepaymentTopTenprogressTable:
    "api/AutoTrans/DashBoard/RepaymentCompanyBaseDestinationNumberBasedTableData",
  RepaymentCompanyBaseBranchBasedProgressTable:
    "api/AutoTrans/DashBoard/RepaymentCompanyBaseBranchBasedProgressChartTableData",
  repaymentTopTenPieChart:
    "api/AutoTrans/DashBoard/RepaymentCompanyBaseDestinationNumberBasedPieChartData",
  repaymentSourceNumberValue: "api/AutoTrans/DashBoard/getSourceNumber",
  CompanyBaseBarChartTableData:
    "api/AutoTrans/DashBoard/CompanyBaseBarChartTableData",
  CompanyBaseLineChartTableData:
    "api/AutoTrans/DashBoard/CompanyBaseLineChartTableData",
  CompanyBasePieChartTableData:
    "api/AutoTrans/DashBoard/CompanyBasePieChartTableData",

  // AT 3rd Group
  individualBaseAutotransferTgTableValue:
    "api/AutoTrans/DashBoard/IndividualBaseTableData",
  individualBaseAutotransferTgDougnutValue:
    "api/AutoTrans/DashBoard/IndividualBaseDonutChart",
  individualBaseAutotransferTgLineValue:
    "api/AutoTrans/DashBoard/IndividualBaseLineChart",
  individualBaseAutotransferTgBarValue:
    "api/AutoTrans/DashBoard/IndividualBaseBarChart",
  individualBaseAutotransferTgProgressValue:
    "api/AutoTrans/DashBoard/IndividualBaseProgressChart",
  individualBaseAutotransferTgProgressTableValue:
    "api/AutoTrans/DashBoard/IndividualBaseDonutChartTableData",
  individualBaseAutotransferTgLineTableValue:
    "api/AutoTrans/DashBoard/IndividualBaseLineChartTableData",
  individualBaseAutotransferTgbarTableValue:
    "api/AutoTrans/DashBoard/IndividualBaseBarChartTableData",

  CompanyBaseBranchWiseATTAable:
    "api/AutoTrans/DashBoard/CompanyBaseBranchBasedTableData",
  ATCbBwProgressTableData:
    "api/AutoTrans/DashBoard/CompanyBaseBranchBasedProgressChartTableData",
  CompanyBaseProgressChartTableData:
    "api/AutoTrans/DashBoard/CompanyBaseProgressChartTableData",
  ATindividualProgressTableData:
    "api/AutoTrans/DashBoard/IndividualBaseProgressChartTableData",
  individualBaseATTgBarTable:
    "api/AutoTrans/DashBoard/IndividualBaseBarChartTableData",
    RefreshAddFiveNumber: "api/AutoTrans/RefreshAddFiveNumber",
};



/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
